import React, {useState, useEffect, useRef} from "react";
import {List} from 'antd';
import GenericDialog from '@common/GenericDialog';
import axios from "@common/axios";
import CircularLoader from "@common/CircularLoader";
import useCurrentConcept from "@hooks/useCurrentConcept";

const GlossaryTermLinks = props => {
    const {glossaryTermId} = props;
    const [glossaryTermLinks, setGlossaryTermLinks] = useState([]);
    const {loadCurrentConcept} = useCurrentConcept();
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState();

    const loadGlossaryTermLinks = (glossaryTerm) => {
        setLoading(true);
        axios.get('/web/ui/glossary/glossaryTermLinks', {params: {glossaryTermId: glossaryTermId}})
            .then(response => {
                setGlossaryTermLinks(response.data);
                setError(undefined);
                setLoading(false);
            }).catch(error => {
            console.error(error);
            setError('Error loading dictionary terms');
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleLinkClick = (conceptId) => {
        if(conceptId) {
            loadCurrentConcept(conceptId);
        }
    };

    useEffect(() => {
        if(!glossaryTermId) {
            return;
        }
        loadGlossaryTermLinks(glossaryTermId);
    }, [glossaryTermId]);


    if(glossaryTermLinks == undefined || glossaryTermLinks.length == 0) {
        return null;
    }

    return (
        <List className="margin-t--m margin-b--m" size="small"
            header={<div className="ch-list-header">Related links</div>}
            bordered
            dataSource={glossaryTermLinks}
            renderItem={(glossaryTermLink) => (
                <List.Item>
                   <a href="#" className="ch-link" onClick={() => handleLinkClick(glossaryTermLink.conceptId)}>{glossaryTermLink.syllabusName} &raquo; {glossaryTermLink.topicName} &raquo; {glossaryTermLink.conceptName}</a>
                </List.Item>
            )}
        />
    );
}

export default GlossaryTermLinks;
